import React from "react";
import { Link, useNavigate } from "react-router-dom";
import DashboardIcon from "@mui/icons-material/Dashboard";
import LogoutIcon from "@mui/icons-material/Logout";
import { GiFarmTractor, GiPlantWatering } from "react-icons/gi";
import "./Sidebar.scss";
import { removeUserToken } from "../../../utils/auth";

function Sidebar({ isOpen, setIsOpen }) {
  const navigate = useNavigate(); // For navigation after logout
  const handleLogout = async () => {
    try {
      // Remove authentication token
      await removeUserToken();

      // Clear client-side storage
      localStorage.clear();
      sessionStorage.clear();

      // Navigate to the home page
      navigate("/", { replace: true });

      // Reload to ensure a clean slate (only if necessary)
      setTimeout(() => {
        window.location.reload();
      }, 100); // Adding a slight delay to ensure navigation completes first
    } catch (error) {
      console.error("Logout failed:", error);
      // Optionally, show a user-friendly notification
      // showToast("Logout failed. Please try again.");
    }
  };
  return (
    <div className={`sidebar ${isOpen ? "open" : "closed"}`}>
      <div className="logo">
        <Link to="/user/home" style={{ textDecoration: "none" }}>
          <img src="/LOGOS/Farmology-Logo-e1687720251448.png" alt="Logo" />
        </Link>
      </div>

      <div className="links">
        <ul>
          <p className="spann">Main</p>
          <Link to="/user/home" style={{ textDecoration: "none" }}>
            <li onClick={() => setIsOpen(false)}>
              <DashboardIcon className="icon" fontSize="large" /> Home
            </li>
          </Link>

          <p className="spann">Features</p>
          <Link to="/user/crop-clinic" style={{ textDecoration: "none" }}>
            <li onClick={() => setIsOpen(false)}>
              <GiPlantWatering className="icon" style={{ fontSize: "20px" }} />
              Crop Clinic
            </li>
          </Link>

          <Link
            to="/user/crop-health-management"
            style={{ textDecoration: "none" }}
          >
            <li onClick={() => setIsOpen(false)}>
              <GiFarmTractor className="icon" style={{ fontSize: "20px" }} />
              All Farms
            </li>
          </Link>

          <p className="spann">Settings</p>
          <li onClick={handleLogout} style={{ cursor: "pointer" }}>
            <LogoutIcon className="icon" /> Log Out
          </li>
        </ul>
      </div>
    </div>
  );
}

export default Sidebar;
